export const getFlutterVersion = () => {
    return localStorage.getItem('flutterVersion') || '0.0.0';
}

export const isFlutterVersionMin = (version) => {
    const flutterVersion = getFlutterVersion();
    return isVersionMin(flutterVersion, version);
}

export const isVersionMin = (a = "", b = "") => {
    if (a === "" || b === "") return false;
    const parsedA = parseVersion(a);
    const parsedB = parseVersion(b);

    if (parsedA[0] > parsedB[0]) return true;
    if (parsedA[0] === parsedB[0] && parsedA[1] > parsedB[1]) return true;
    if (parsedA[0] === parsedB[0] && parsedA[1] === parsedB[1] && parsedA[2] >= parsedB[2]) return true;
    return false;
}

const parseVersion = (version) => {
    if (version === "") return [0,0,0];
    return version.split(".").map(e => parseInt(e));
}
